import { render, staticRenderFns } from "./guavaPay.vue?vue&type=template&id=7359accb&scoped=true"
import script from "./guavaPay.vue?vue&type=script&lang=js"
export * from "./guavaPay.vue?vue&type=script&lang=js"
import style0 from "./guavaPay.vue?vue&type=style&index=0&id=7359accb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7359accb",
  null
  
)

export default component.exports